import React from "react";
import { Trans } from "@bookingcom/lingojs-react";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { ClockIcon } from "@bookingcom/bui-assets-react/streamline";
import { TimelineLegInfo } from "./TimelineLegInfo.js";
import Frame from "../../Frame/index.js";
import styles from "./TimelineLeg.module.css";
import useUserAgent from "../../../../hooks/useUserAgent.js";
import { TimelineLeg as TimelineLegUI } from "@flights/search-ui";
import { useTimelineLegController } from "./useTimelineLeg.controller.js";
export const TimelineLeg = (props) => {
    const { leg, shouldHideAnythingBeneath, idx } = props;
    const { isMobile } = useUserAgent();
    const { getTimelineLegFormattedData } = useTimelineLegController();
    const { departure, arrival, isSmall } = getTimelineLegFormattedData(leg);
    const legInfo = React.createElement(TimelineLegInfoElement, { ...props });
    const technicalStopsBlock = React.createElement(TimelineLegTechnicalStopElement, { ...props });
    let contentBetween, contentOnSide;
    if (isMobile) {
        contentBetween = (React.createElement(Frame, { pt: 4 },
            legInfo,
            technicalStopsBlock));
        contentOnSide = null;
    }
    else {
        contentBetween = technicalStopsBlock;
        contentOnSide = legInfo;
    }
    return (React.createElement(TimelineLegUI, { departure: departure, arrival: arrival, contentBetweenDepartureAndArrival: contentBetween, contentOnSide: contentOnSide, className: shouldHideAnythingBeneath ? styles.hideAnythingBeneath : undefined, attributes: { "data-testid": `timeline_leg_${idx}` }, isSmall: isSmall }));
};
export function TimelineLegInfoElement(props) {
    const { leg } = props;
    return React.createElement(TimelineLegInfo, { leg: leg });
}
export function TimelineLegTechnicalStopElement(props) {
    const { leg, noPadding } = props;
    const { getTimelineLegFormattedData } = useTimelineLegController();
    const { technicalStops } = getTimelineLegFormattedData(leg);
    if (!technicalStops.length)
        return null;
    return (React.createElement(Stack, { gap: 2, alignItems: "center", direction: "row", mixin: noPadding ? undefined : { paddingBlockStart: 8, paddingBlockEnd: 4, paddingInlineStart: 2 }, attributes: { "data-testid": "timeline_leg_stop" } },
        React.createElement(Icon, { svg: ClockIcon, size: "small", color: "neutral_alt" }),
        React.createElement(Text, null,
            React.createElement(Trans, { tag: "flights_itinerary_technical_stop", variables: { airport_code: technicalStops.map((stop) => stop.airportCode.code).join(",") } }))));
}
export function getTimelineLegData(props) {
    const { getTimelineLegFormattedData, leg } = props;
    const { departure, arrival } = getTimelineLegFormattedData(leg);
    return [
        {
            type: "point",
            dateTime: [departure.date, departure.time].filter(Boolean).join(" · "),
            airport: [departure.iata, departure.name].filter(Boolean).join(" · "),
            flightInfo: React.createElement(TimelineLegInfoElement, { ...props }),
            content: React.createElement(TimelineLegTechnicalStopElement, { ...props, noPadding: true })
        },
        {
            type: "point",
            dateTime: [arrival.date, arrival.time].filter(Boolean).join(" · "),
            airport: [arrival.iata, arrival.name].filter(Boolean).join(" · ")
        }
    ];
}
